import { postRequest } from 'src/services/requests';
import { ControleAcessoMenuDTO } from '../types/dtos/genericos';

const salvarControleAcesso = (
  acessos: ControleAcessoMenuDTO[]
): Promise<void> => {
  return new Promise((resolve, reject) => {
    postRequest(
      '/genericos/ge/ControleAcessoMenu/Salvar',
      acessos,
      () => resolve(),
      reject
    );
  });
};

export { salvarControleAcesso };
